import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import InternalLink from '../Navigation/InternalLink';
import { useAuth } from '../../contexts/AuthContext';

const Start = () => {
  const { isAuthenticated } = useAuth();
  const [clientCards, setClientCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated) {
      fetchClientLinks();
    }
  }, [isAuthenticated]);

  const fetchClientLinks = async () => {
    setIsLoading(true);
    try {
      const response = await fetch('/api/v1/client', {
        method: 'GET',
        credentials: 'include',
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.links) {
          // Filter out the client home and logout links
          const filteredLinks = data.links.filter(link => 
            link.url !== '/client' && 
            link.url !== '/logout' && 
            link.name !== 'Выйти'
          );
          setClientCards(filteredLinks);
        } else {
          // Default fallback if API doesn't return expected data
          setClientCards(defaultCards);
        }
      } else {
        setClientCards(defaultCards);
      }
    } catch (error) {
      console.error('Error fetching client links:', error);
      setClientCards(defaultCards);
    } finally {
      setIsLoading(false);
    }
  };

  // Default cards if API fails
  const defaultCards = [
    { name: 'Видео', url: '/client/videos' },
    { name: 'Лекции', url: '/education' },
    { name: 'Полезные материалы', url: '/client/useful-materials' },
    { name: 'Написать в техподдержку', url: '/support', icon: 'support', old: true }
  ];

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#c0834d]"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12 md:py-16 max-w-7xl">
      <div className="flex flex-col items-center">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10">
          Информация для клиентов
        </h2>

        <div className="w-full justify-center items-center gap-[20px] xl:gap-2.5 flex flex-col lg:flex-row">
          <Link 
            to="/about" 
            className="bg-gradient-to-r from-[#6082a0] to-[#e55961] rounded-[20px] justify-center items-center gap-4 flex overflow-hidden w-full max-w-[320px] xs:w-[320px] xl:w-[252px] h-[47px] z-10 text-white text-[16px] font-bold font-['Open Sans']"
          >
            Что такое APM
          </Link>
          <a 
            href="mailto:support@ruscomtech.ru?subject=Консультация" 
            className="px-5 py-2.5 bg-[#c0834d] rounded-[20px] justify-center items-center gap-2.5 flex w-full max-w-[320px] xs:w-[320px] xl:w-[252px] h-[47px] z-10 text-white text-[16px] lg:text-base font-bold font-['Open Sans']"
          >
            Пилот
          </a>
        </div>

        <div className="w-full max-w-5xl mt-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {clientCards.map((card, index) => (
              <div key={index} className="border border-gray-200 rounded hover:shadow-md transition-shadow">
                <div className="flex flex-col h-full">
                  <div className="p-6 text-center flex-grow">
                    {card.old ? <InternalLink link={card.url} className="no-underline">
                      <h3 className="text-xl font-semibold text-[#c0834d] mb-2">
                        {card.name}
                      </h3>
                    </InternalLink> : 
                    <Link to={card.url} className="no-underline">
                      <h3 className="text-xl font-semibold text-[#c0834d] mb-2">
                        {card.name}
                      </h3>
                    </Link>}
                  </div>
                  <div className="p-4 text-center border-t border-gray-100">
                    {card.old ? <InternalLink link={card.url} className="text-[#d1606b] hover:underline">
                      Подробнее &gt;&gt;
                    </InternalLink> : 
                    <Link to={card.url} className="text-[#d1606b] hover:underline">
                      Подробнее &gt;&gt;
                    </Link>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Start;